<template>
  <div v-if="!loading">
    <page-header>
      <h1 v-if="quoteSession.ashp">Explore the impact of Air-Source Heat Pumps</h1>
      <h1 v-else-if="quoteSession.solar">Explore the impact of Solar and Battery</h1>
      <h1 v-else-if="quoteSession.evCompare || quoteSession.evOnly">Explore the benefit of adopting an EV</h1>
    </page-header>

    <div class="container">
      <div v-if="result">
        <electric-vehicle-results v-if="quoteSession.evOnly || quoteSession.evCompare" />
        <solar-battery-results v-if="quoteSession.solar" />
        <air-source-heat-pump-results v-if="quoteSession.ashp" />
      </div>

      <div class="alert alert-info _margin-top-20" v-if="!loading && !result">
        No result found
      </div>
    </div>
  </div>
  <div v-else class="quote-loader">

  </div>
</template>

<script>
import PageHeader from '@/components/page-header/PageHeader';
import ElectricVehicleResults from '@/components/quote-results/ElectricVehicleResults';
import SolarBatteryResults from '@/components/quote-results/SolarBatteryResults';
import AirSourceHeatPumpResults from '@/components/quote-results/AirSourceHeatPumpResults';

import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'QuoteResults',
  data() {
    return {
      form: {
        ashpFinanceOptions: {
          apr: null,
          deposit: null,
          repaymentLength: null,
          totalAssetCost: null,
          monthlyRepayment: null,
          totalInterestPaid: null,
          totalPayment: null
        },
        enquire: {
          fullName: null,
          email: null,
          phone: null,
          contactTime: null,
          loyalInformation: null,
          info: null,
          adopt: null
        }
      },
      aprList: [...Array(11).keys()].map(n => ({
        id: n, label: `${n}%`
      })),
      inflationList: [...Array(11).keys()].map(n => ({
        id: n, label: `${n}%`
      })),
      termList: [...Array(20).keys()].map(n => ({
        id: 12 * (n + 1), label: `${(n + 1)} year${n == 0 ? '' : 's'}`
      })),
      currentYear: new Date().getFullYear(),
      breakEvenYear: null,
      breakEvenChartData: [],
      breakDown: {},
      showBreakdown: true,
      showRates: false,
      showEnquire: false
    };
  },
  async mounted() {
    await this.$store.dispatch('quote_results/getQuoteResults');

    if (this.quoteSession.solar || this.quoteSession.ashp) {
      await this.$store.dispatch('lookups/getEsaPropertyList');
    }

    this.$store.dispatch('quote/setQuoteType', this.switchType);
    this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Viewed' });
    this.$store.dispatch('tracing/saveActions');
  },
  validations() {
    return {
      form: {
        ashpFinanceOptions: {
          deposit: { required },
          repaymentLength: { required }
        },
        enquire: {
          fullName: { required },
          phone: { required },
          email: { required },
          contactTime: { required },
          loyalInformation: { required }
        }
      }
    };
  },
  computed: {
    ...mapState({
      result: ({ quote_results }) => quote_results.result,
      switchType: ({ session }) => session.quote.switchType,
      quoteSession: ({ session }) => session.quote_journey_session,
      loading: ({ page_loader }) => page_loader.show
    })
  },
  components: {
    PageHeader,
    ElectricVehicleResults,
    SolarBatteryResults,
    AirSourceHeatPumpResults
  }
};
</script>

<style lang="scss">
.quote-loader {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

}
</style>
